import UnknownChapter from './UnknownChapter';
import NtcChapter from './NtcChapter';
import SportHubDirectory from './SportHub/Directory';
import SportHubExperience from './SportHub/Experience';
import MembershipChapter from './MembershipChapter';
import ApparelPodChapter from './ApparelPodChapter';
import UniversalTakeoverPlayer from './UniversalTakeoverPlayer';
import ServicesMenuChapter from "./SevicesMenu/ServicesMenuChapter";
import ActivityChapter from './Activity/ActivityChapter';
import ServiceHubDirectoryChapter from './one-nike/sport-hub/DirectoryChapter';
import ServiceHubPosterChapter from './Poster/PosterChapter';
import ProductIntroChapter from './365-story/ProductIntroChapter';
import CarouselChapter from './365-story/CarouselChapter';
import NbyChapter from './365-story/NbyChapter';
import NbyAttractChapter from './365-story/NbyAttractChapter';
import MediaChapter from './365-story/MediaChapter';
import ColorChapter from './ColorChapter';
import CampaignIntroChapter from './365-story/CampaignIntroChapter';


export const REGISTER = {
    unknown: UnknownChapter,
    ntc: NtcChapter,
    sport_hub_directory: SportHubDirectory,
    sport_hub_experience: SportHubExperience,
    membership: MembershipChapter,
    apparel_pod: ApparelPodChapter,
    media: MediaChapter,
    color: ColorChapter,
    universal_takeover: UniversalTakeoverPlayer,
    services_menu: ServicesMenuChapter,
    activity: ActivityChapter,
    service_hub_menu: ServicesMenuChapter,
    service_hub_directory: ServiceHubDirectoryChapter,
    service_hub_poster: ServiceHubPosterChapter,
    product_intro: ProductIntroChapter,
    carousel: CarouselChapter,
    nby: NbyChapter,
    nby_attract_video: NbyAttractChapter,
    campaign_intro: CampaignIntroChapter,
};

export function getChapter(key: string) {
    return REGISTER[key] || REGISTER.unknown;
}
